import React from 'react';
import ReactDOM from 'react-dom';
import SeriesView from 'Views/SeriesView';
import Controller from './Controller';

export default class SeriesController extends Controller{

  static boot(){
    Controller.boot(...arguments);
    FW.store.loaded('mediaSeries', () => {
      window.MediaSeries = FW.store.get('mediaSeries');
      ReactDOM.render(<SeriesView series={window.MediaSeries} />, document.getElementById('series-' + window.MediaSeries.get('id')));
      if (FW.inEditor()) window.parent.FW.editor.addType('mediaSeries', window.MediaSeries);
      FW.trigger('booted');
    });

  }

}
